<div class="flex flex-row asset-annotator">
  <div class="w-[68%] mr-4" *ngIf="isSupported">
    <div class="flex flex-row pb-2 justify-between">
      <div class="w-[70%]">
        <h1 class="text-3xl font-bold">Please annotate your remarks.*</h1>
      </div>
      <div class="asset-annotator-actions" *ngIf="!readOnly && !videoEditorComp?.isVideoPlaying">
        <!--First button and its menu-->
        <button mat-raised-button [matMenuTriggerFor]="shapeLine" class="tool-btn" i18n-matTooltip matTooltip="Set shape">
          <mat-icon class="material-icons-outlined">shape_line</mat-icon>
        </button>
        <mat-menu #shapeLine="matMenu" class="annotation-menu">
          <button type="button" mat-menu-item (click)="drawToolClick('rectangle')"><mat-icon class="material-icons-outlined">square</mat-icon>Square</button>
          <button type="button" mat-menu-item (click)="drawToolClick('pen')"><mat-icon class="material-icons-outlined">gesture</mat-icon>Pen</button>
          <button type="button" mat-menu-item (click)="drawToolClick('circle')"><mat-icon class="material-icons-outlined">circle</mat-icon>Circle</button>
          <button type="button" mat-menu-item (click)="drawToolClick('marker')"><mat-icon class="material-icons-outlined">mode_edit_outline</mat-icon>Marker</button>
        </mat-menu>
        <!--Second button and its menu-->
        <button mat-raised-button [matMenuTriggerFor]="colorLens" class="tool-btn" i18n-matTooltip matTooltip="Set color">
          <mat-icon class="material-icons-outlined">color_lens</mat-icon>
        </button>
        <mat-menu #colorLens="matMenu" class="annotation-color-menu">
          <div class="grid grid-cols-4 px-2">
            <button type="button" mat-menu-item (click)="setColor('#FFFFFF')">
              <mat-icon class="!m-0">radio_button_unchecked</mat-icon>
            </button>
            <button type="button" mat-menu-item (click)="setColor('#FF0000')">
              <mat-icon class="!text-[#FF0000] !m-0">circle</mat-icon>
            </button>
            <button type="button" mat-menu-item (click)="setColor('#00FF00')">
              <mat-icon class="!text-[#00FF00] !m-0">circle</mat-icon>
            </button>
            <button type="button" mat-menu-item (click)="setColor('#0000FF')">
              <mat-icon class="!text-[#0000FF] !m-0">circle</mat-icon>
            </button>
            <button type="button" mat-menu-item (click)="setColor('#888888')">
              <mat-icon class="!text-[#888888] !m-0">circle</mat-icon>
            </button>
            <button type="button" mat-menu-item (click)="setColor('#000000')">
              <mat-icon class="!text-[#000000] !m-0">circle</mat-icon>
            </button>
            <button type="button" mat-menu-item (click)="setColor('#FFFF00')">
              <mat-icon class="!text-[#FFFF00] !m-0">circle</mat-icon>
            </button>
            <button type="button" mat-menu-item (click)="setColor('#FF00FF')">
              <mat-icon class="!text-[#FF00FF] !m-0">circle</mat-icon>
            </button>
          </div>
        </mat-menu>
        <!--Third button and its menu-->
        <button mat-raised-button [matMenuTriggerFor]="lineWeight" class="tool-btn" i18n-matTooltip matTooltip="Set line weight">
          <mat-icon class="material-icons-outlined">line_weight</mat-icon>
        </button>
        <mat-menu #lineWeight="matMenu" class="annotation-line-stroke w-36">
          <div class="grid grid-row-4">
            <div mat-menu-item class="!flex space-x-1 items-center" (click)="setStroke(1)">
              <div class="text-[0.9rem] w-16">1 Pt.</div>
              <div class="!border-[1px] !border-black w-full"></div>
            </div>
            <div mat-menu-item class="!flex space-x-1 items-center" (click)="setStroke(2)">
              <div class="text-[0.9rem] w-16">2 Pt.</div>
              <div class="!border-[2px] !border-black w-full"></div>
            </div>
            <div mat-menu-item class="!flex space-x-1 items-center" (click)="setStroke(4)">
              <div class="text-[0.9rem] w-16">4 Pt.</div>
              <div class="!border-[4px] !border-black w-full"></div>
            </div>
            <div mat-menu-item class="!flex space-x-1 items-center" (click)="setStroke(6)">
              <div class="text-[0.9rem] w-16">6 Pt.</div>
              <div class="!border-[6px] !border-black w-full"></div>
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
    <div class="widget-bg-color w-full rounded-2xl p-4 h-full">
      <!--Image window-->
      <div *ngIf="asset && asset.assetType === assetTypes.Image" class="relative">
        <thehubz-image-editor #imageEditor [fileUrl]="fileUrl" (openFullScreenClick)="openAssetFullscreen()"> </thehubz-image-editor>
      </div>
      <!--Video window-->
      <div *ngIf="asset && asset.assetType === assetTypes.Video" class="relative" #videoContainer>
        <thehubz-video-editor #videoEditor [fileUrl]="fileUrl" (openFullScreenClick)="openVideoFullscreen()"> </thehubz-video-editor>
      </div>
      <!--PDF window-->
      <div *ngIf="asset && asset.assetType === assetTypes.Pdf" class="relative">
        <thehubz-pdf-editor #pdfEditor [fileUrl]="fileUrl" (openFullScreenClick)="openAssetFullscreen()"> </thehubz-pdf-editor>
      </div>
    </div>
  </div>
  <div class="w-[68%] mr-4" *ngIf="!isSupported">
    <div class="flex flex-row pb-2">
      <div class="w-[100%]">
        <h1 class="text-3xl font-bold">Please comment your remarks.*</h1>
      </div>
    </div>
    <div class="widget-bg-color w-full rounded-2xl p-4">
      <div class="relative">
        <thehubz-asset-view *ngIf="asset" [data]="asset"></thehubz-asset-view>
      </div>
    </div>
  </div>
  <div class="w-[32%] h-full relative">
    <thehubz-annotation-comments
      #commentsArea
      [externalFlag]="sharedFlag"
      [annotations]="assetAnnotatorService.annotations"
      [assetType]="(asset && asset.assetType) || ''"
      [readOnly]="readOnly"
      [annotationDrawn]="annotationDrawn"
      (timestampClick)="annotationTimeClick($event)"
      (pageClick)="annotationPageClick($event)"
      (toggleClick)="toggleAnnotation($event)"
      (editClick)="onEditClick($event)"
      (deleteClick)="onDeleteClick($event)"
      (replyClick)="replyToAnnotation($event)"
      (editReplyClick)="editReply($event)"
      (deleteReplyClick)="deleteReply($event)"
      (replyToReplyClick)="replyToReply($event)"
      (saveAnnotationsClick)="onSaveClick($event)"
    >
    </thehubz-annotation-comments>
  </div>
</div>
